<template>
    <section class="header-section">
        <div
            class="header-section__bg"
            :class="`header-section__bg--${bannerEffect}`"
            :style="bannerStyle"
        >
            <div class="header-section__content">
                <div class="header-section__top">
                    <a href="https://kendoo.com" class="header-section__logo-link">
                        <img
                            class="header-section__logo"
                            src="@/assets/img/svg/logo.svg"
                            alt="Kendoo"
                        />
                    </a>
                    <!-- logged in: name + sign out share the logo's row, and wrap
                         below it if there isn't room for both side by side -->
                    <TournamentLoginFormComponent
                        v-if="showLoginForm && player.is_authorized"
                        :player="player"
                        :tournament="tournament"
                    />
                </div>
                <!-- guest: the sign-up/sign-in card gets its own centered row -->
                <TournamentLoginFormComponent
                    v-if="showLoginForm && !player.is_authorized"
                    :player="player"
                    :tournament="tournament"
                />
                <TournamentTimePlateComponent
                    :tournament="tournament"
                    :date-locale="dateLocale"
                    :date-time-zone="dateTimeZone"
                />
            </div>
        </div>
    </section>
</template>

<script>
import TournamentTimePlateComponent from "@/pages/tournament/components/tournament_time_plate_component";
import TournamentLoginFormComponent from "@/pages/tournament/components/tournament_login_form_component";

export default {
    name: "TournamentHeaderSection",
    props: {
        tournament: {},
        player: {},
        dateLocale: {
            type: String,
            default: undefined,
        },
        dateTimeZone: {
            type: String,
            default: undefined,
        },

        showLoginForm: {
            type: Boolean,
            default: true,
        },

        // banner overlays: 'full' — vignette, glow and colour blob;
        // 'soft' — edge vignette only, no glow or colour blob; 'none' — bare art
        bannerEffect: {
            type: String,
            default: 'full',
        }
    },

    components: {
        TournamentTimePlateComponent,
        TournamentLoginFormComponent,
    },

    computed: {
        bannerStyle() {
            const bannerURL = this.tournament.banner_url;
            if (bannerURL) {
                // same eased edge fades as .header-section__bg--soft
                const edgeVignette = (alphas) => {
                    const fade = alphas
                        .map((alpha, i) => `rgba(0, 0, 0, ${alpha}) ${(i * 1.6).toFixed(1)}rem`)
                        .concat('rgba(0, 0, 0, 0) 8rem')
                        .join(', ');
                    return ['bottom', 'top', 'right', 'left']
                        .map(side => `linear-gradient(to ${side}, ${fade}), `).join('');
                };
                const vignette = {
                    full: 'radial-gradient(50% 50.04% at 50% 50.04%, rgba(0, 0, 0, 0.40) 0%, rgba(0, 0, 0, 0.80) 100%), ',
                    soft: edgeVignette([0.55, 0.36, 0.2, 0.08, 0.02]),
                }[this.bannerEffect] || '';
                return `background-image: ${vignette}url("${bannerURL}");`;
            }
            return ''
        },
    }
}
</script>

